import Alpine from 'alpinejs';
import "./js/customSelect.js";
import "./js/menuSlider.js";

import interact from "interactjs";
import Swiper from "swiper";
import { Navigation, Pagination } from 'swiper/modules';
import "./js/productPageSlider";
import './js/cmsSliders';


var checkoutShippingSwiper = undefined;
const checkoutShippingSwiperId = ".shippingAddress-swiper";
const checkoutShippingSwiperConfig = {
    slidesPerView: 1.25,
    spaceBetween: 15,
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },
    pagination: {
        el: ".swiper-pagination",
    },
    breakpoints: {
        769: {
            slidesPerView: 2,
        },
    },
    modules: [Navigation, Pagination],
};

function RefreshShippingAddressSwiper() {
    checkoutShippingSwiper = new Swiper(checkoutShippingSwiperId, checkoutShippingSwiperConfig);
}

var checkoutBillingSwiper = undefined;
const checkoutBillingSwiperId = ".billingAddress-swiper";
const checkoutBillingSwiperConfig = {
    slidesPerView: 1.25,
    spaceBetween: 15,
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },
    pagination: {
        el: ".swiper-pagination",
    },
    breakpoints: {
        769: {
            slidesPerView: 2,
        },
    },
    modules: [Navigation, Pagination],
};

function RefreshBillingAddressSwiper() {
    checkoutBillingSwiper = new Swiper(checkoutBillingSwiperId, checkoutBillingSwiperConfig);
}

document.addEventListener("DOMContentLoaded", function () {
    //window.alpineInitTree = Alpine.initTree.bind(Alpine);
    Alpine.start();

    new Swiper('.bag-swiper', {
        slidesPerView: "1.7",
        spaceBetween: 22,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        breakpoints: {
            769: {
                spaceBetween: 50,
                slidesPerView: '3',
            },
        },
        modules: [Navigation],
    });

    new Swiper('.sample-swiper', {
        slidesPerView: "3.56",
        spaceBetween: 15,
        breakpoints: {
            769: {
                spaceBetween: 30,
                slidesPerView: "4.13",
            },
        },
    });

    interact('.draggable')
        .draggable({
            passive: false,
            onmove: dragMoveListener,
            onend: function (event) {
                event.target.classList.remove('dragging')
                event.target.removeAttribute("data-x");
                event.target.removeAttribute("data-y");
                event.target.style.transform = "translate(0px, 0px)";
            },
            modifiers: [
                interact.modifiers.restrictRect({
                    restriction: document.querySelector('#container'),
                    endOnly: true,
                }),
            ],
        });


    function dragMoveListener(event) {
        var target = event.target,
            x = (parseFloat(target.getAttribute('data-x')) || 0) + event.dx,
            y = (parseFloat(target.getAttribute('data-y')) || 0) + event.dy;
        if (window.innerWidth < 767) {
            target.classList.add('dragging')
            target.style.webkitTransform =
                target.style.transform =
                'translate(' + x + 'px, ' + y + 'px)';
            target.setAttribute('data-x', x);
            target.setAttribute('data-y', y);
        }
    }

    interact('.dropzone').dropzone({
        overlap: 0.80,
        ondropactivate: function (event) {
            event.target.classList.add('drop-active');
        },
        ondragenter: function (event) {
            var draggableElement = event.relatedTarget,
                dropzoneElement = event.target;
            dropzoneElement.classList.add('drop-target');
            draggableElement.classList.add('can-drop');
        },
        ondragleave: function (event) {
            event.target.classList.remove('drop-target');
            event.relatedTarget.classList.remove('can-drop');
            event.relatedTarget.classList.remove('drop-ok');
        },
        ondrop: function (event) {
            event.relatedTarget.classList.add('drop-ok');
        },
        ondropdeactivate: function (event) {
            event.target.classList.remove('drop-active');
            event.target.classList.remove('drop-target');
        }
    });

});

document.addEventListener("limelife.checkout.shippingaddress.loaded", function () {
    RefreshShippingAddressSwiper();
});

document.addEventListener("limelife.checkout.billingaddress.loaded", function () {
    RefreshBillingAddressSwiper();
});

window.copyToClipboard = function (text) {
    if (navigator.clipboard) {
        try {
            navigator.clipboard.writeText(text).then(
                () => {
                    // succeed
                },
                (ex) => {
                    console.error('Copy to clipboard failed: ', ex);
                }
            );
        }
        catch (ex) {
            console.error('Copy to clipboard failed: ', ex);
        }
    }
    else {
        var area = document.createElement("textarea");
        area.value = text;

        // Avoid scrolling to bottom
        area.style.top = "0";
        area.style.left = "0";
        area.style.position = "fixed";

        document.body.appendChild(area);
        area.focus();
        area.select();

        try {
            var successful = document.execCommand('copy');
            if (successful) {

            }
            else {
                console.error('Copy to clipboard failed without error');
            }
        }
        catch (ex) {
            console.error('Copy to clipboard failed: ', ex);
        }

        document.body.removeChild(area);
    }
};

